import React from "react";

export default (WrappedComponent, interval) => {
  class HocComponent extends React.Component {
    componentDidMount() {
      this.timer = setInterval(() => this.forceUpdate(), interval);
    }

    componentWillUnmount() {
      clearInterval(this.timer);
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return HocComponent;
};
